// extracted by mini-css-extract-plugin
module.exports = {"container":"expiration-date_container__18CG-","icon":"expiration-date_icon__3aiax","text":"expiration-date_text__2egIA","date":"expiration-date_date__YT_0C"};